import LanguagesManagerDetail from './LanguagesManagerDetail'
export default LanguagesManagerDetail
